import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CxoneEtlReportingSetService } from "../../../cxone-etl-reporting-set.service";
import { CONTACTHIERARCHY, ETLReportingSetFlowbuilderModules, ETLReportingSetObj, EmployeeGroupListType, HierarchyGroup, ParentOutputFormType } from "../../../cxone-etl-reporting-set.model";

@Component({
    selector: "cv-contact-group",
    templateUrl: "./contact-group.component.html",
    styleUrls: ["./contact-group.component.scss"],
})
export class ContactGroupComponent implements OnInit {
    @Output() contactGroupData = new EventEmitter();
    @Input() selectedSection = "";
    @Input() reportingSetName = "";
    public selectedSectionItem = "";
    public contactGroupList: EmployeeGroupListType[];
    public checkbox = false;
    private selectedItem: EmployeeGroupListType = null;
    @Input() set hierarchyGroupClickedItem(data) {
        if (data) {
            this.updateSelectedSectionItem(data);
        }
    }

    constructor(private cxoneEtlReportingSet: CxoneEtlReportingSetService) { }

    async ngOnInit() {
        await this.initializeContactGroupData();
    }

    async initializeContactGroupData() {
        const hierarchyGroup = (await this.cxoneEtlReportingSet.getHierarchyGroups());
        let contactKeyObjs: string[] = [];
        const reportingSetData: ETLReportingSetObj = this.cxoneEtlReportingSet.getReportingSetData();
        let contactHierarchyData = {};
        if (reportingSetData && Object.keys(reportingSetData).length) { // we have some existing data 
            contactHierarchyData = reportingSetData?.ContactHierarchy;
            CONTACTHIERARCHY.forEach((key, index) => {
                const reportingSetKey = Object.keys(reportingSetData.ContactHierarchy)[index];
                if (reportingSetKey) {
                    // Assign the value to contactHierarchyData with the corresponding key from CONTACTHIERARCHY
                    contactHierarchyData[key] = reportingSetData.ContactHierarchy[reportingSetKey];
                }
            });
            const empHierarchyDataExist = Object.keys(contactHierarchyData).length !== 0;
            contactKeyObjs = empHierarchyDataExist && Object.keys(contactHierarchyData);
        }

        this.contactGroupList = hierarchyGroup
            .filter((item: HierarchyGroup) => item.BaseGroupType === 1)
            .sort((a, b) => b.GroupLevel - a.GroupLevel)
            .map((contactObjItem) => {
                let contactObj: EmployeeGroupListType = {
                    GroupTypeName: contactObjItem.GroupTypeName,
                    GroupData: contactObjItem
                };
                if (contactKeyObjs.length) {
                    contactKeyObjs.sort();
                    const lowercaseEmpKeyObjs = contactKeyObjs.map(key => key.toLowerCase());
                    const lowercaseGroupTypeName = contactObj.GroupTypeName.toLowerCase().replace(/\s/g, '');
                    const matchingIndex = lowercaseEmpKeyObjs.findIndex(key => key.includes(lowercaseGroupTypeName));
                    if (matchingIndex !== -1) {
                        contactObj.GroupData = { [contactKeyObjs[matchingIndex]]: contactHierarchyData[contactKeyObjs[matchingIndex]] };
                        contactKeyObjs.splice(matchingIndex, 1);
                    }
                }
                return contactObj;
            });
    }

    handleClicked(event, item: EmployeeGroupListType) {
        this.selectedItem = item;
        this.contactGroupData.emit(item);
    }

    updateSelectedSectionItem(item) {
        this.selectedSectionItem = item?.GroupTypeName || item?.selectedItem;
        if (this.selectedItem) {
            this.cxoneEtlReportingSet.updateData({ selectedSectionName: this.selectedSectionItem, isNew: !this.toggleStatusCompletedIcon(this.selectedItem.GroupData) });
        }
    }

    setContactGroupPayload(payload: ParentOutputFormType, selectedContactGroup: string) {
        this.contactGroupList = this.contactGroupList.map((contactGrp) => {
            if (contactGrp.GroupTypeName === selectedContactGroup) {
                contactGrp.GroupData = payload;
            }
            return contactGrp;
        })
    }

    toggleStatusCompletedIcon(groupData) {
        return Object.keys(groupData).length === 1;
    }
}